import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

import "./CertificationCard.css";

export default function CertificationCard({ certification }) {
  return (
    <div className="certification-card" key={certification.name}>
      <h2>{certification.title}</h2>
      <h3>{certification.issuer}</h3>
      <p>Issued {certification.issueDate}</p>
      <p>Credential ID {certification.credentialId}</p>
      <a href={certification.credentialUrl} target="_blank" rel="noreferrer">
        View Credential
        <FaExternalLinkAlt className="external-icon" />
      </a>
    </div>
  );
}
